export default "__VITE_ASSET__nWq39QKO__"